import { AuthenticationService } from '../../app/core/authentication/authentication.service';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { ErrorService } from '../../app/core/error/error.service';
import { UserService } from '../../app/services/user/user.service';


@IonicPage({
  name: 'home'
})
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  
  public error: Observable<any>;
  public user: Observable<any>;

  public name: '';
  public password: '';
  public email: '';
  public checkbox: boolean;
  public prevPage: any;
  loginForm: any;
  public privacyItems: any;
  public privacyValid: boolean;
  public formValid: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams, 
    public viewCtrl: ViewController, 
    private auth: AuthenticationService,
    private errorService: ErrorService,
    private userService: UserService
  ) {
    this.privacyItems = [
      { name: 'PRIVACY_1' , value: false},
    ];
    this.loginForm = new FormGroup({
      name: new FormControl(this.name, {
        validators: [Validators.required]
      }),
      password: new FormControl(this.password, {
        validators: [Validators.required, Validators.minLength(8)]
      }),
      email: new FormControl(this.email, {
        validators: [Validators.required]
      }),
      checkbox: new FormControl(this.checkbox, {
        validators: [Validators.required]
      })
    });

    this.error = this.errorService.isError$;
    this.user = this.userService.currentUser$;
    this.errorService.addError(null);
  }

  ionViewDidLoad() {
    if(this.navCtrl.getPrevious() !== null){
      this.prevPage = this.navCtrl.getPrevious().id;
    }
    this.loginForm.valueChanges.subscribe((val) => {
      if(this.loginForm && this.loginForm.valid && this.checkbox['value'] === true){
        this.formValid = true;
      } else {
        this.formValid = false;
      }
    })
  }

  goToSim(){
    if(this.loginForm.valid){
      this.auth.registration(this.name, this.password, this.email, this.privacyValid)
      this.user.subscribe(user => {
        if(user){
          this.error = null;
          this.navCtrl.push('congratulations', {
            email: this.email
          });
        }
      })
    }
    this.loginForm.controls['name'].markAsTouched()
    this.loginForm.controls['password'].markAsTouched()
    this.loginForm.controls['email'].markAsTouched()
  }

  goToLogin(){
    this.navCtrl.push('login');
  }

  onPrivacyCheckbox(value){
    this.privacyValid = !this.privacyValid;
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts